// extracted by mini-css-extract-plugin
export default {"CountriesOverlay":"zdgHD","country":"_6MNOD","col":"mohM9","icon":"_4qIOl","name":"_6aPYI","skeleton-progress":"cppt9"};